import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';

import { Heading } from '../components/Heading';
import ExchangeRates from '../components/ExchangeRates';
import MonthPicker from '../components/MonthPicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faSync, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

export function Financial() {
    const navigate = useNavigate();
    const [refreshKey, setRefreshKey] = useState(0);
    const [filters, setFilters] = useState({
        type: '',
        period: ''
    });

    const handleReload = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
        setRefreshKey(prev => prev + 1);
    };

    const clearFilter = (name) => {
        setFilters(prev => ({
            ...prev,
            [name]: ''
        }));
        setRefreshKey(prev => prev + 1);
    };

    const title = 'Financieros';

    return (
        <>
            <Heading title={title} />

            <div className="nav-back-container mb-4">
                <button className="nav-back-btn" onClick={() => navigate('/payments')}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <span>Ventas</span>
                </button>
            </div>

            <section className="container mt-5 pb-4 border-bottom border-secondary">
                {/* Filters Row */}
                <div className="row g-4 align-items-end">
                    <div className="col-md-4 col-lg-3">
                        <label className="fw-bold mb-3 d-block text-white" style={{ fontSize: '1.1rem' }}>Tipo</label>
                        <div className="d-flex gap-2">
                            <select
                                className="form-select bg-dark text-white border-secondary py-2"
                                name="type"
                                value={filters.type}
                                onChange={handleFilterChange}
                            >
                                <option value="">Todos</option>
                                <option value="USD_MXN">USD_MXN</option>
                                <option value="INGRAM">INGRAM</option>
                            </select>
                        </div>
                    </div>

                    <div className="col-md-5 col-lg-4">
                        <div className="d-flex align-items-end gap-2">
                            <MonthPicker
                                label="Periodo"
                                value={filters.period}
                                onChange={(value) => handleFilterChange({ target: { name: 'period', value } })}
                            />
                            <button
                                className="btn btn-ink-icon"
                                onClick={handleReload}
                                title="Recargar datos"
                            >
                                <FontAwesomeIcon icon={faSync} />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Feedback Row (to avoid layout shift) */}
                <div className="row mt-3">
                    <div className="col-12">
                        {(filters.type !== '' || filters.period !== '') && (
                            <div className="d-flex gap-2 flex-wrap">
                                {filters.type !== '' && (
                                    <div className="d-inline-flex align-items-center bg-dark border border-secondary rounded px-3 py-1 gap-2">
                                        <span className="text-white-50 small">Tipo:</span>
                                        <span className="text-white small fw-medium">{filters.type}</span>
                                        <button
                                            onClick={() => clearFilter('type')}
                                            className="btn btn-link p-0 text-danger"
                                            style={{ textDecoration: 'none', lineHeight: 1 }}
                                        >
                                            <FontAwesomeIcon icon={faClose} size="sm" />
                                        </button>
                                    </div>
                                )}
                                {filters.period !== '' && (
                                    <div className="d-inline-flex align-items-center bg-dark border border-secondary rounded px-3 py-1 gap-2">
                                        <span className="text-white-50 small">Periodo:</span>
                                        <span className="text-white small fw-medium">{filters.period}</span>
                                        <button
                                            onClick={() => clearFilter('period')}
                                            className="btn btn-link p-0 text-danger"
                                            style={{ textDecoration: 'none', lineHeight: 1 }}
                                        >
                                            <FontAwesomeIcon icon={faClose} size="sm" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </section>

            <div className="container mt-4">
                <ExchangeRates filters={filters} refreshKey={refreshKey} />
            </div>
        </>
    )
}

export default Financial
